// tslint:disable file-name-casing
import i18next from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import enTranslations from 'data/translations/en';

i18next
  .use(initReactI18next)
  .use(ICU)
  .init({
    fallbackLng: 'en',
    resources: { ...{ en: enTranslations } },
    ns: ['common'],
    defaultNS: 'common',
    // Only enable if I18N_DEBUG=yes; avoids console flood and UI freeze when many components re-render (e.g. client selection in compset menu)
    debug: Env.I18N_DEBUG === 'yes',
    interpolation: {
      escapeValue: false,
    },
    nsSeparator: '.',
    parseMissingKeyHandler: (key: string) => {
      // todo :: currently strips the missing namespace only
      // if you are debugging, then add a wrapper for <span color="red"> or something similar
      const replacedKey = key.replace(/^([a-z]+[A-z]+\.)+/, '');
      return Env.TRANSLATION_KEYS_ENABLED === 'yes' ? key : replacedKey;
    },
  });

export default i18next;
